import {
  Text,
  RichText,
  withDatasourceCheck,
  Field,
  ComponentRendering,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { useSitecoreContext } from 'hooks/useSitecoreContext';
import { ComponentProps } from 'lib/component-props';
import { useMemo } from 'react';
import useHelpers from 'src/hooks/helpers';

type Fields = {
  description: Field<string>;
  title: Field<string>;
};

type BaseHeadingProps = ComponentProps & {
  fields: Fields;
  rendering: ComponentRendering;
  headingSize?: string;
  descriptionClassName?: string;
  titleClassName?: string;
  className?: string;
};

const BaseHeading = ({
  fields,
  rendering,
  headingSize = 'h2',
  descriptionClassName = 'body-large mt-4',
  titleClassName,
  className,
}: BaseHeadingProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isExperienceEditor = sitecoreContext.pageEditing;
  const { anchorId } = useHelpers(rendering);
  const haveTitle = useMemo(() => {
    return !!fields?.title?.value;
  }, [fields]);
  const haveDescription = useMemo(() => {
    return !!fields?.description?.value;
  }, [fields]);
  const showBaseHeading = useMemo(() => {
    return haveTitle || haveDescription || isExperienceEditor;
  }, [haveTitle, haveDescription, isExperienceEditor]);
  return (
    <>
      {showBaseHeading && (
        <div className={`w-100 ${className}`} id={anchorId}>
          <Text
            tag={headingSize}
            className={`background-to-change ${titleClassName}`}
            field={fields.title}
          />
          <RichText
            tag="p"
            className={`background-to-change ${descriptionClassName}`}
            field={fields.description}
          />
        </div>
      )}
    </>
  );
};

export default withDatasourceCheck()<BaseHeadingProps>(BaseHeading);
